import { initSelectors } from '@behavior/init';
import { Responsive } from 'semantic-ui-react';
import ButtonWrapper from '@components/common/ButtonWrapper';
import { UserDTO } from '@behavior/init/dto/UserDTO';
import useUser from '@behavior/init/getUserV2';

type Props = {
  history: any;
};

const BatchUpdateButton = ({ history }: Props) => {
  const { user } = useUser();
  const isRender =
    initSelectors.isAdmin(user) ||
    initSelectors.isHseDeveloper(user) ||
    initSelectors.isChemicalSafetyExpert(user) ||
    initSelectors.isDSO(user) ||
    initSelectors.isEditor(user);

  return (
    <Responsive minWidth={768} className="displayInlineBlock">
      {isRender && (
        <ButtonWrapper
          label="inventory.overview.page.view.options.container.batch.update.button"
          type="button"
          icon="list"
          onClick={() => {
            history.push(`/batchUpdate`);
          }}
        />
      )}
    </Responsive>
  );
};

export default BatchUpdateButton;
